import React, { useContext } from 'react';
import { BrowserRouter as Router, Route, Routes, Navigate } from 'react-router-dom';
import { Bounce, ToastContainer } from 'react-toastify';

import Register from './pages/Register';
import Login from './pages/Login';
import CommissionOverview from './pages/CommissionOverview';
// import Dashboard from './pages/Dashboard';
// import TargetList from './pages/TargetList';
// import PartnershipPage from './pages/PartnershipPage';
import { UserProvider, UserContext } from './context/UserContext';
import CompanyProfile from './pages/CompanyProfile';
import ClientCompanyProfile from './pages/ClientCompanyProfile';
import ProductsPage from './pages/ProductsPage';
import QueriesProvider from './queries/QueriesProvider';
import RoleBasedGuard from './components/RoleGuard';
import { USER_ROLES } from './constants';
import SettingsPage from './pages/Settings';
import Layout from './components/Layout';
import ClientCommissionOverview from './pages/ClientCommissionOverview';
import ProspectsPage from './pages/ProspectsPage';
import EngagePage from './pages/EngagePage';
import Home from './pages/Home';
import GenericContentPage from './pages/GenericContentPage';
import AuthCallback from './pages/AuthCallback';
import LeadAgentsPage from './pages/LeadAgentsPage';
import ContentPage from './pages/ContentPage';
import ArticleFormPage from './pages/ArticleFormPage';
import AdminCompanyProfileSetup from './pages/AdminCompanyProfileSetup';
import AdminAiSettings from './pages/AdminAiSettings';
import AdminAiLogs from './pages/AdminAiLogs';
import AdminKnowledgeBase from './pages/AdminKnowledgeBase';
import FooterLayout from './components/FooterLayout';
import DeviceGuard from './components/DeviceGuard';

function AppContent() {
  const { user } = useContext(UserContext);
  const getDefaultRedirect = () => {
    if (user?.role === USER_ROLES.CLIENT) return '/programs';
    if (user?.role === USER_ROLES.LEAD_AGENT || user?.role === USER_ROLES.ADMIN) return '/opportunities';
    return '/dashboard';
  };

  return (
    <Layout>
      <Routes>
        {/* Admin content routes first so /content matches exactly (not /content/:pageType) */}
        {user && (
          <>
            <Route
              path='/content/articles/new'
              element={
                <RoleBasedGuard roles={[USER_ROLES.ADMIN]}>
                  <ArticleFormPage />
                </RoleBasedGuard>
              }
            />
            <Route
              path='/content/articles/:id'
              element={
                <RoleBasedGuard roles={[USER_ROLES.ADMIN]}>
                  <ArticleFormPage />
                </RoleBasedGuard>
              }
            />
            <Route
              path='/content'
              element={
                <RoleBasedGuard roles={[USER_ROLES.ADMIN]}>
                  <ContentPage />
                </RoleBasedGuard>
              }
            />
            <Route
              path='/company-profile-setup'
              element={
                <RoleBasedGuard roles={[USER_ROLES.ADMIN]}>
                  <AdminCompanyProfileSetup />
                </RoleBasedGuard>
              }
            />
            <Route
              path='/ai-settings'
              element={
                <RoleBasedGuard roles={[USER_ROLES.ADMIN]}>
                  <AdminAiSettings />
                </RoleBasedGuard>
              }
            />
            <Route
              path='/ai-logs'
              element={
                <RoleBasedGuard roles={[USER_ROLES.ADMIN]}>
                  <AdminAiLogs />
                </RoleBasedGuard>
              }
            />
            <Route
              path='/knowledge-base'
              element={
                <RoleBasedGuard roles={[USER_ROLES.ADMIN]}>
                  <AdminKnowledgeBase />
                </RoleBasedGuard>
              }
            />
          </>
        )}
        <Route
          path='/content/:pageType'
          element={
            <FooterLayout>
              <GenericContentPage />
            </FooterLayout>
          }
        />
        {!user ? (
          <>
            <Route path='/' element={<Home />} />
            <Route
              path='/register'
              element={
                <DeviceGuard>
                  <FooterLayout>
                    <Register />
                  </FooterLayout>
                </DeviceGuard>
              }
            />
            <Route
              path='/login'
              element={
                <DeviceGuard>
                  <FooterLayout>
                    <Login />
                  </FooterLayout>
                </DeviceGuard>
              }
            />
            <Route
              path='/auth/success'
              element={
                <FooterLayout>
                  <AuthCallback />
                </FooterLayout>
              }
            />
            <Route
              path='*'
              element={
                <FooterLayout>
                  <Navigate to='/login' replace />
                </FooterLayout>
              }
            />
          </>
        ) : (
          <>
            <Route
              path='/programs'
              element={
                <RoleBasedGuard roles={[USER_ROLES.CLIENT]}>
                  <CompanyProfile />
                </RoleBasedGuard>
              }
            />
            <Route
              path='/prospects'
              element={
                <RoleBasedGuard roles={[USER_ROLES.CLIENT, USER_ROLES.LEAD_AGENT]}>
                  <ProspectsPage />
                </RoleBasedGuard>
              }
            />
            <Route
              path='/engage'
              element={
                <RoleBasedGuard roles={[USER_ROLES.LEAD_AGENT]}>
                  <EngagePage />
                </RoleBasedGuard>
              }
            />
            <Route
              path='/client-commission-overview'
              element={
                <RoleBasedGuard roles={[USER_ROLES.CLIENT]}>
                  <ClientCommissionOverview />
                </RoleBasedGuard>
              }
            />
            <Route
              path='/company-profile'
              element={
                <RoleBasedGuard roles={[USER_ROLES.CLIENT]}>
                  <ClientCompanyProfile />
                </RoleBasedGuard>
              }
            />
            <Route
              path='/opportunities'
              element={
                <RoleBasedGuard roles={[USER_ROLES.ADMIN, USER_ROLES.LEAD_AGENT]}>
                  <ProductsPage />
                </RoleBasedGuard>
              }
            />
            <Route
              path='/settings'
              element={
                <RoleBasedGuard roles={[USER_ROLES.LEAD_AGENT]}>
                  <SettingsPage />
                </RoleBasedGuard>
              }
            />
            <Route
              path='/lead-agents'
              element={
                <RoleBasedGuard roles={[USER_ROLES.ADMIN]}>
                  <LeadAgentsPage />
                </RoleBasedGuard>
              }
            />
            <Route
              path='/commission-overview'
              element={
                <RoleBasedGuard roles={[USER_ROLES.ADMIN, USER_ROLES.LEAD_AGENT]}>
                  <CommissionOverview />
                </RoleBasedGuard>
              }
            />
            {/*<Route path='/dashboard' element={<Dashboard />} />*/}
            {/*<Route path='/target-list' element={<TargetList />} />*/}
            {/*<Route path='/target-list/client1' element={<TargetList />} />*/}
            {/*<Route path='/target-list/client2' element={<TargetList />} />*/}
            {/*<Route path='/target-list/client3' element={<TargetList />} />*/}
            {/*<Route path='/partnership-profiles' element={<PartnershipPage />} />*/}
            <Route path='*' element={<Navigate to={getDefaultRedirect()} replace />} />
          </>
        )}
      </Routes>
    </Layout>
  );
}

function App() {
  return (
    <QueriesProvider>
      <Router>
        <UserProvider>
          <ToastContainer
            position='top-right'
            autoClose={5000}
            theme='light'
            closeOnClick
            pauseOnHover={false}
            pauseOnFocusLoss={false}
            transition={Bounce}
            stacked
          />
          <AppContent />
        </UserProvider>
      </Router>
    </QueriesProvider>
  );
}

export default App;
